import { LOCALE_ID, Provider } from '@angular/core'
import {
  LocaleService,
  StorageService,
  WindowService,
  EnvironmentName,
} from 'shared-services'
import { environmentNameToken } from './environment-name.token'

export const localeServiceProvider: Provider = {
  provide: LocaleService,
  useFactory: (
    storageService: StorageService,
    localeId: string,
    windowService: WindowService,
    environmentName: EnvironmentName,
  ): LocaleService => {
    return new LocaleService(
      storageService,
      localeId,
      windowService,
      environmentName,
    )
  },
  deps: [StorageService, LOCALE_ID, WindowService, environmentNameToken],
}
